import React from 'react'
import {
  Button,
  Col,
  FormGroup,
  Input,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap'

import { MiniLoading, Select } from "../../components/revel-strap"

import { numberFunc, } from '../../utils'

import { StockGroupModel, StockZoneModel } from '../../models'

const stock_group_model = new StockGroupModel()
const stock_zone_model = new StockZoneModel()

class ProductPoorModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      is_loading: true,
      stock_poor_qty: 0,
      stock_poor_remark: '',
      stock_group_code: '',
      stock_zone_code: '',
      stock_groups: [],
      stock_zones: [],
    }
  }

  componentDidUpdate(props_old) {
    if (!props_old.show && this.props.show) {
      this._fetchData()
    }
  }

  _fetchData = () => this.setState({ is_loading: true, }, async () => {
    const product_modal_type = this.props.product_modal_type
    let stock_group_code, stock_zone_code, stock_poor_remark = ''
    let stock_poor_qty = 0
    let product_list = []

    product_modal_type === 'product-poor' ? product_list = this.props.product_poor_list : product_list = this.props.product_return_list

    if (product_list && product_modal_type === 'product-poor') {
      stock_group_code = product_list.stock_group_poor_code
    } else if (product_list && product_modal_type === 'product-return') {
      stock_group_code = product_list.stock_group_return_code
    }

    const stock_groups = await stock_group_model.getStockGroupBy()
    const stock_zones = await stock_zone_model.getStockZoneBy({
      indicator: {
        stock_group_code: stock_group_code || stock_groups.data[0].stock_group_code
      },
    })

    if (product_list && product_list.length == 0) {
      stock_poor_qty = 0
      stock_poor_remark = ''
      stock_group_code = stock_groups.data.length ? stock_groups.data[0].stock_group_code : ''
      stock_zone_code = stock_zones.data.length ? stock_zones.data[0].stock_zone_code : ''
    } else {
      if (product_modal_type === 'product-poor') {
        stock_poor_qty = product_list.stock_poor_qty
        stock_poor_remark = product_list.stock_poor_remark
        stock_group_code = product_list.stock_group_poor_code
        stock_zone_code = product_list.stock_zone_poor_code
      } else {
        stock_poor_qty = product_list.stock_return_qty
        stock_poor_remark = product_list.stock_return_remark
        stock_group_code = product_list.stock_group_return_code
        stock_zone_code = product_list.stock_zone_return_code
      }
    }

    this.setState({
      is_loading: false,
      stock_poor_qty: stock_poor_qty,
      stock_poor_remark: stock_poor_remark,
      stock_group_code: stock_group_code,
      stock_zone_code: stock_zone_code,
      stock_groups: stock_groups.data,
      stock_zones: stock_zones.data
    })
  })

  _getStockGroupData = async (e) => {
    let stock_zones = await stock_zone_model.getStockZoneBy({
      indicator: { stock_group_code: e },
    })

    this.setState({
      stock_group_code: e,
      stock_zone_code: stock_zones.data.length ? stock_zones.data[0].stock_zone_code : '',
      stock_zones: stock_zones.data
    })
  }

  _handleSave = () => {
    let data = {}
    data.stock_poor_qty = numberFunc.toInt(this.state.stock_poor_qty)
    data.stock_poor_remark = this.state.stock_poor_remark
    data.stock_group_poor_code = this.state.stock_group_code
    data.stock_zone_poor_code = this.state.stock_zone_code
    data.idx = this.props.idx

    this.props.onSave(data)
  }

  _handleClose = () => this.props.onClose()

  render() {

    const stock_group_options = [...this.state.stock_groups.map(item => ({
      label: item.stock_group_name, value: item.stock_group_code,
    }))]

    const stock_zone_options = [...this.state.stock_zones.map(item => ({
      label: item.stock_zone_name, value: item.stock_zone_code,
    }))]

    return (
      <Modal size="lg" centered isOpen={this.props.show} toggle={this._handleClose}>
        <ModalHeader toggle={this._handleClose}>
          {this.props.product_modal_type === 'product-poor' ? 'สินค้ามีปัญหา' : 'สินค้าเศษ'}
        </ModalHeader>
        <ModalBody>
          {this.state.is_loading ? (
            <div className="text-center pt-4">
              <MiniLoading className="mx-auto" /> กำลังโหลดข้อมูล
            </div>
          ) : (
            <>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <label>ไปที่คลัง </label>
                    <Select
                      options={stock_group_options}
                      value={this.state.stock_group_code}
                      onChange={(e) => { this._getStockGroupData(e) }}
                    />
                    <p className="text-muted m-0">Example : คลังหลังร้าน.</p>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label>ไปที่โซน</label>
                    <Select
                      options={stock_zone_options}
                      value={this.state.stock_zone_code}
                      onChange={(e) => this.setState({ stock_zone_code: e })}
                    />
                    <p className="text-muted m-0">Example : A1.</p>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <label>จำนวน</label>
                    <Input
                      type="number"
                      style={{ height: 50 }}
                      value={this.state.stock_poor_qty}
                      onChange={(e) => this.setState({ stock_poor_qty: e.target.value })}
                      required
                    />
                    <p className="text-muted m-0">Example : 0.</p>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <label>หมายเหตุ</label>
                    <Input
                      type="textarea"
                      value={this.state.stock_poor_remark}
                      onChange={(e) => this.setState({ stock_poor_remark: e.target.value })}
                      required
                    />
                    <p className="text-muted m-0">Example : .</p>
                  </FormGroup>
                </Col>
              </Row>
            </>
          )
          }
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="primary" onClick={this._handleSave}>บันทึก</Button>
          <Button type="button" onClick={this._handleClose}>ยกเลิก</Button>
        </ModalFooter>
      </Modal >
    )
  }
}

export default ProductPoorModal